import mandatoryLoginFavoris from "./mandatoryLoginFavoris"
export default mandatoryLoginFavoris;
